module.exports = __webpack_public_path__ + "static/media/zflb_moren.af9af8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/zflb_moren.png
// module id = 2185
// module chunks = 0